<div class="agpr-mfaManagement">
    <div *ngIf="addNewMethod" class="agpr-mfaManagement-addNew-container">
        {{ 'Mfa.setup.heading' | localize}}
        <agpr-button
            class="agpr-mfaManagement-addNew-button"
            icon="fa-regular fa-duotone fa-square-plus"
            [tooltip]="'Mfa.management.createNew.heading'"
            (click)="createNew()"
            [style]="buttonTypes.icon"
        ></agpr-button>
    </div>
    <agpr-scroll-panel class="agpr-mfaManagement-scrollPanel">
        <agpr-table
            [id]="'mfaManagement'"
            class="agpr-mfaManagement-table"
            [ngClass]="{'agpr-mfaManagement-table--noContent': dataRows.length === 0}"
            [columns]="columnDefs"
            [(ngModel)]="dataRows"
            [enableSelectAll]="false"
        ></agpr-table>
        <div *ngIf="dataRows.length === 0 && addNewMethod" class="agpr-mfaManagement-noMethodContainer">
            <span role="img" class="fa-regular fa-duotone fa-file-slash"></span>
            <span> {{ 'Mfa.setup.noAuths' | localize }} </span>
            <agpr-button
                class="agpr-mfaManagement-addNew-linkButton"
                [label]="'Mfa.setup.noAuths.button'"
                tabindex="0"
                (click)="createNew()"
                [style]="buttonTypes.link"
            ></agpr-button>
        </div>
    </agpr-scroll-panel>
</div>

<ng-template let-row="row" let-column="column" let-rowIndex="rowIndex" #methodNameCell>
    <div class="agpr-mfaManagement-table-methodName">
        <span
            class="agpr-mfaManagement-table-methodName-value"
        >
            {{ row[column.field] }}
        </span>
        <span
            *ngIf="row.originalData.preferred"
            class="fa-solid fa-star agpr-mfaManagement-table-preferredIcon"
            agprTooltip="Mfa.management.preferred"
        ></span>
    </div>
</ng-template>

<ng-template let-row="row" let-column="column" let-rowIndex="rowIndex" #actionCell>
    <div class="agpr-mfaManagement-table-action">
        <agpr-split-button
            *ngIf="row.actions.length > 0"
            class="agpr-mfaManagement-table-splitButton"
            [id]="row.id + '_actions'"
            [style]="buttonTypes.icon"
            [showTriggerIcon]="false"
            icon='fa-light fa-ellipsis-vertical'
            [options]="row.actions"
            [data]="row"
            [panelPositionY]="'top'"
            panelPositionX="right"
        ></agpr-split-button>
    </div>
</ng-template>

